import { render, staticRenderFns } from "./skeleton-card-small.vue?vue&type=template&id=6ea33d80&"
import script from "./skeleton-card-small.vue?vue&type=script&lang=js&"
export * from "./skeleton-card-small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports